import type {
  FilterItemsByBreakpointProps,
  ItemWithBreakpoints,
  ThemeBreakpoint,
  ThemeBreakpoints,
} from "./theme-breakpoints.type";

export const getActiveBreakpoint = (bp: ThemeBreakpoints): ThemeBreakpoint => {
  if (bp.xxxl) return "xxxl";
  if (bp.xxl) return "xxl";
  if (bp.xl) return "xl";
  if (bp.lg) return "lg";
  if (bp.md) return "md";
  if (bp.sm) return "sm";
  return "xs";
};

/**
 * Filters an array of items based on the active breakpoint
 */
export const filterItemsByBreakpoint = <Item extends ItemWithBreakpoints>({
  items,
  activeBreakpoint,
}: FilterItemsByBreakpointProps<Item>) => {
  return items.filter(
    (item) =>
      item.breakpoints === "*" || item.breakpoints?.includes(activeBreakpoint)
  );
};
